export default {"src":"/_next/static/media/nufi.80cef7e5.svg","height":32,"width":100,"blurWidth":0,"blurHeight":0};